import React from 'react';
import RefreshIndicator from 'material-ui/RefreshIndicator';


export default () => {

  const style = {
    container: {
      position: "fixed",
      top: "50%",
      zIndex: 100,
      left: "50%",
    },
    refresh: {
      display: 'inline-block',
      position: 'relative',
    },
  };
  
  return (
    <div style={style.container}>
      <RefreshIndicator
          size={40}
          left={10}
          top={0}
          status="loading"
          style={style.refresh}
      />
  </div>
  );
}




// WEBPACK FOOTER //
// ./src/components/Page/PageLoader.jsx